import { Component, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { DataService } from 'src/app/core/services/data/data.service';
import { IGbInvoiceJobLock } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-gb-invoice-job-management',
  standalone: true,
  imports: [MatButtonModule, MatCardModule, MatSnackBarModule, IgxGridModule],
  templateUrl: './gb-invoice-job-management.component.html',
  styleUrl: './gb-invoice-job-management.component.scss'
})
export class GbInvoiceJobManagementComponent implements OnInit {
  jobs: IGbInvoiceJobLock[] = [];
  isLoading = false;

  private readonly dataService = inject(DataService);
  private readonly snackBar = inject(MatSnackBar);

  ngOnInit(): void {
    this.refreshJobs();
  }

  refreshJobs(): void {
    this.isLoading = true;
    this.dataService.GetActiveGbInvoiceJobs().subscribe({
      next: (jobs) => (this.jobs = jobs),
      error: () => {
        this.isLoading = false;
        this.snackBar.open('Unable to load active GB invoice jobs.', 'Close', { duration: 5000 });
      },
      complete: () => (this.isLoading = false),
    });
  }

  releaseLock(job: IGbInvoiceJobLock): void {
    const confirmed = window.confirm(
      `Release the lock for lot ${job.lotNumber}? Only do this if the job is no longer running.`,
    );
    if (!confirmed) return;

    this.dataService.ReleaseGbInvoiceJobLock(job.lockId).subscribe({
      next: () => {
        this.snackBar.open(`Lock released for lot ${job.lotNumber}.`, 'Close', { duration: 5000 });
        this.refreshJobs();
      },
      error: () => this.snackBar.open('Unable to release the GB invoice job lock.', 'Close', { duration: 5000 }),
    });
  }

  formatDate(value: string): string {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
  }
}
